"use strict";
//创建人：bai.zhiming
//日期：2016-8-24
//描述：产品管理微信服务
angular.module("manageSysCategoryRelationServiceModule", ["manageSysCategoryRelationModifyModule"])
    .factory("manageSysCategoryRelationService", ["$q", "trsHttpService", "$modal", function($q, trsHttpService, $modal) {
        return {
            /**
             * [modifySubscription description] 修改弹窗
             * @param  {[type]} success [description]
             * @return {[type]}         [description]
             */
            categoryRelationModify: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: "manageConfig/sysManageMent/categoryRelation/service/categoryRelationModify/categoryRelationModify_tpl.html",
                    windowClass: "sysManageMent-categoryRelation-modify",
                    backdrop: false,
                    controller: "manageSysCategoryRelationModifyCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                return modalInstance.result.then(function(data) {
                    success(data);
                });
            }
        };
    }]);
